import { Program } from '../interfaces/pmi/program.entity';
import { IdNameType, KeyString, PmiConvention } from './types';


export const pmiStatusNames: KeyString = {
	0: 'En construcción',
	1: 'Cerrado',
	2: 'Finalizado',
	3: 'En revisión',
	4: 'No completado',
	5: 'Sin iniciar',
};

export enum moduleNames {
	autoevaluation = 'Autoevaluación',
	plan = 'Plan de mejoramiento',
	tracking = 'Seguimiento',
	route = 'Ruta de mejoramiento',
	institutions = 'Instituciones',
	documents = 'Documentos',
	users = 'Usuarios',
	resources = 'Recursos',
	inventary = 'Inventario',
	reserves = 'Reservas',
	projects = 'Proyectos',
}

export const pmiConventions: PmiConvention[] = [
	{
		prefix: 'NI',
		name: 'No iniciada',
	},
	{
		prefix: 'ESP',
		name: 'En espera',
	},
	{
		prefix: 'CANC',
		name: 'Cancelada',
	},
	{
		prefix: 'EJE',
		name: 'En ejecución',
	},
	{
		prefix: 'FIN',
		name: 'Finalizada',
	},
];

export const monthsList: string[] = [
	'Enero',
	'Febrero',
	'Marzo',
	'Abril',
	'Mayo',
	'Junio',
	'Julio',
	'Agosto',
	'Septiembre',
	'Octubre',
	'Noviembre',
	'Diciembre',
];

export const asignatures: IdNameType[] = [
	{ id: '1', name: 'Ciencias naturales y educación ambiental' },
	{
		id: '2',
		name: 'Ciencias sociales, historia, geografía, constitución políticay democracia',
	},
	{ id: '3', name: 'Educación artística y cultural' },
	{ id: '4', name: 'Educación ética y en valores humanos' },
	{ id: '5', name: 'Educación física, recreación y deportes' },
	{ id: '6', name: 'Educación religiosa' },
	{ id: '7', name: 'Humanidades, lengua castellana e idiomasextranjeros' },
	{ id: '8', name: 'Matemáticas' },
	{ id: '9', name: 'Tecnología e informática' },
];

export const reservationIntentions: IdNameType[] = [
	{ id: '1', name: 'Plan de aula' },
	{ id: '2', name: 'Plan de area' },
	{ id: '3', name: 'Proyecto transversal' },
	{ id: '4', name: 'Proyecto Pedagógico Productivo' },
	{ id: '5', name: 'Actividad de clase' },
];

export const projectProgramsMock: Program[] = [
	{
		id: '182bc20e-35d9-4f5e-b0dc-70535dcbc9b5',
		name: 'Pruebas Saber',
		version: 1,
		components: [],
	},
	{
		id: '4a3e3c5b-5335-4a90-8013-5d2605a7ca35',
		name: 'Pileo',
		version: 1,
		components: [],
	},
	{
		id: 'aaccceac-f65a-4773-bc6c-7183998cac44',
		name: 'Bilingüismo',
		version: 1,
		components: [],
	},
	{
		id: 'c1a569d6-aca5-4a70-bdd4-44b312607bae',
		name: 'Inclusión',
		version: 1,
		components: [],
	},
	{
		id: '4119af9d-e167-42d1-9b35-06ca8e243b95',
		name: 'Medios y TIC',
		version: 1,
		components: [],
	},
];

export const chartColors = [
	'#a93226',
	'#2874a6',
	'#7d3c98',
	'#d4ac0d',
	'#ca6f1e',
	'#196f3d',
];

export const formatDate = 'yyyy-LL-dd';
export const formatDateTime = 'yyyy-LL-dd hh:mm:ss';
export const maxFileSize = 50000; // In kilobytes

export enum BitacoraStatuses {
	success=200,
	bad_request=400,
	preconditions_required=428,
	server_error=500
}